// Clamps [data-read-more-content] with CSS and shows the [data-read-more-toggle] button only
// when the content is actually cut off. The button toggles the clamp and swaps its label with
// data-less-label. The height change is animated through an inline max-height, since CSS cannot
// transition to max-height: none.
if (!customElements.get('medic-star-read-more')) {
  class MedicStarReadMore extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-read-more-content]');
      this.toggle = this.querySelector('[data-read-more-toggle]');
      if (!this.content || !this.toggle) return;

      this.moreLabel = this.toggle.textContent.trim();
      this.lessLabel = this.toggle.dataset.lessLabel || this.moreLabel;
      this.toggle.hidden = this.content.scrollHeight <= this.content.clientHeight + 1;
      this.toggle.addEventListener('click', () => {
        if (this.classList.contains('is-expanded')) {
          this.collapse();
        } else {
          this.expand();
        }
      });
      this.content.addEventListener('transitionend', (event) => {
        if (event.target === this.content && this.classList.contains('is-expanded')) {
          this.content.style.maxHeight = '';
        }
      });
    }

    expand() {
      this.setLabel(true);
      if (this.reducedMotion()) {
        this.classList.add('is-expanded');
        return;
      }

      this.content.style.maxHeight = `${this.content.clientHeight}px`;
      this.classList.add('is-expanded');
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    }

    collapse() {
      this.setLabel(false);
      if (this.reducedMotion()) {
        this.classList.remove('is-expanded');
        return;
      }

      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
      // Commit the start height before the clamp returns, so the transition has a start value.
      this.content.getBoundingClientRect();
      this.classList.remove('is-expanded');
      this.content.style.maxHeight = '';
    }

    setLabel(expanded) {
      this.toggle.textContent = expanded ? this.lessLabel : this.moreLabel;
      this.toggle.setAttribute('aria-expanded', expanded);
    }

    reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  }

  customElements.define('medic-star-read-more', MedicStarReadMore);
}
